/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconArrowRight8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowRight8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path d="m2.333 1.471 2.431 2.431-2.431 2.431.471.472 2.903-2.903L2.804 1l-.471.471Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconArrowRight12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowRight12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path d="m3.5 2.207 3.646 3.647L3.5 9.5l.707.707 4.354-4.353L4.207 1.5l-.707.707Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconArrowRight16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowRight16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path d="m4.667 2.943 4.862 4.862-4.862 4.862.943.942 5.804-5.804L5.61 2l-.943.943Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconArrowRight20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowRight20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="m5.833 3.678 6.078 6.078-6.078 6.077 1.178 1.179 7.256-7.256L7.011 2.5 5.833 3.678Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowRight24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowRight24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="m7 4.414 7.293 7.293L7 19l1.414 1.414 8.707-8.707L8.414 3 7 4.414Z" fill="currentColor" />
        </SVGContainer>
    );
});

export const IconArrowRight = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowRight(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconArrowRight8 {...iconProps} />;
        case '12':
            return <IconArrowRight12 {...iconProps} />;
        case '16':
            return <IconArrowRight16 {...iconProps} />;
        case '20':
            return <IconArrowRight20 {...iconProps} />;
        case '24':
            return <IconArrowRight24 {...iconProps} />;
        default:
            return <IconArrowRight24 {...iconProps} />;
    }
});
